export const dutch = {
    'Development version': 'Ontwikkelversie',
    'Trending videos': 'Trending video\'s',
    'Recently uploaded': 'Recent geüpload',
    'Recommended': 'Aanbevolen',
    'At the moment there are no videos in this section.': 'Op het moment zijn er geen videos in deze sectie.',
    'If you are patient, this section will be automatically refilled.': 'Als u even geduld heeft wordt deze sectie automatisch bijgevuld.',
    'views': 'weergaven',
    'Type here to search...': 'Typ hier om te zoeken...',
    'No results found.': 'Geen resultaten gevonden.',
    '${value|keep} search results found': '${value|keep} zoekresultaten gevonden',
    'No results were found for ${query|keep}. Try other keywords to get search results.': 'Er zijn geen resultaten gevonden voor ${query|keep}. Probeer andere zoekwoorden om resultaten te vinden.',
    'years': 'jaar',
    'Your VAT declaration per country for ${date|keep}': 'Uw BTW aangifte per land voor ${date|keep}',
    'Your income of monthly subscriptions for ${date|keep}': 'Uw inkomen uit maandelijkse lidmaatschappen voor ${date|keep}',
    'Your income of quarterly subscriptions for ${date|keep}': 'Uw inkomen uit driemaandelijkse lidmaatschappen voor ${date|keep}',
    'Your income of yearly subscriptions for ${date|keep}': 'Uw inkomen uit jaarlijkse lidmaatschappen voor ${date|keep}',
    'Your total income for ${date|keep}': 'Uw totale inkomen voor ${date|keep}',
    'You don\'t have to file a VAT return.': 'U hoeft geen BTW aangifte te doen.',
    'Items per page:': 'Items per pagina',
    'of': 'van',
    'Country': 'Land',
    'State': 'Staat',
    'Amount': 'Hoeveelheid',
    'Quarterly': 'Driemaandelijks',
    'Quarterly subscription': 'Driemaandelijks abonnement',
    'Quarterly price': 'Driemaandelijkse prijs',
    'Currency': 'Valuta',
    'No records were found': 'Er zijn geen records gevonden',
    'Active monthly subscriptions': 'Actieve maandelijkse abonnementen',
    'Active quarterly subscriptions': 'Actieve driemaandelijkse abonnementen',
    'Active yearly subscriptions': 'Actieve jaarlijkse abonnementen',
    'year': 'jaar',
    'Uploaded videos': 'Geüploade video\'s',
    'Registered users': 'Geregistreerde gebruikers',
    'months': 'maanden',
    'Draft': 'Concept',
    'Analytics': 'Statistieken',
    'month': 'maand',
    'days': 'dagen',
    'User': 'Gebruiker',
    'day': 'dag',
    'hours': 'uur',
    'hour': 'uur',
    'minutes': 'minuten',
    'minute': 'minuut',
    'seconds': 'seconden',
    'Or': 'Of',
    'second': 'seconde',
    'ago': 'geleden',
    'Load more...': 'Meer laden...',
    'Account settings': 'Account instellingen',
    'Membership and invoicing': 'Lidmaatschap en facturering',
    'Email address': 'E-mailadres',
    'Password': 'Wachtwoord',
    'Phone number': 'Telefoonnummer',
    'Subscription information': 'Abonnementgegevens',
    'Monthly': 'Maandelijks',
    'Yearly': 'Jaarlijks',
    'This subscription will automatically renew and can be canceled on a monthly basis.': 'Dit abonnement wordt automatisch hernieuwd en is maandelijks opzegbaar.',
    'This subscription will NOT automatically renew.': 'Dit abonnement wordt NIET automatisch hernieuwd.',
    'Billing information': 'Factureringsgegevens',
    'You have not subscribed yet. This means that you do not have access to the paid video content. Go to the settings to purchase a subscription.': 'U heeft nog geen lidmaatschap afgesloten. Dit betekent dat u geen toegang heeft tot de betaalde videocontent. Ga naar de instellingen om een lidmaatschap af te sluiten.',
    'My profile': 'Mijn profiel',
    'Take subscription': 'Neem abonnement',
    'Profile image': 'Profielafbeelding',
    'Edit': 'Wijzigen',
    'Invoice to Media evolution. VAT reverse charge.': 'Te factureren aan Media evolution. BTW verlegd.',
    'To be billed to Media Evolution. This amount includes VAT.': 'Te factureren aan Media Evolution. Dit bedrag is inclusief BTW.',
    'For all questions you can reach us via': 'Voor alle vragen kunt u ons bereiken via',
    'we try to respond within 24 hours.': 'wij proberen binnen 24 uur te reageren.',
    'incl. VAT': 'incl. BTW',
    'excl. VAT': 'excl. BTW',
    'E.g. 23444': 'Bijv. 6600WE',
    'Zip code': 'Postcode',
    'Update': 'Bijwerken',
    'Add new section': 'Voeg een nieuwe sectie toe',
    'Monthly price': 'Maandelijkse prijs',
    'Yearly price': 'Jaarlijkse prijs',
    'General analytics': 'Algemene statistieken',
    'Income analytics': 'Inkomsten statistieken',
    'View': 'Bekijken',
    'Your currency will be used throughout the platform.': 'Uw valuta wordt overal op het platform gebruikt.',
    'Personal settings': 'Persoonlijke instellingen',
    'Restart': 'Herstarten',
    'Rewind {seektime}s': '{seektime}s terugspoelen',
    'Play': 'Afspelen',
    'Pause': 'Pauzeren',
    'VAT shifted?': 'BTW verlegd?',
    'Forward {seektime}s': '{seektime}s verder',
    'Seek': 'Zoeken',
    'Played': 'Afgespeeld',
    'Buffered': 'Gebufferd',
    'Current time': 'Huidige tijd',
    'Download all invoices': 'Download alle facturen',
    'Download all invoices for ${date|keep}': 'Download alle facturen van ${date|keep}',
    'Duration': 'Duur',
    'Volume': 'Volume',
    'Mute': 'Dempen',
    'Unmute': 'Dempen opheffen',
    'Enable captions': 'Enable captions',
    'Disable captions': 'Ondertiteling inschakelen',
    'Enter fullscreen': 'Volledig scherm inschakelen',
    'Exit fullscreen': 'Volledig scherm uitschakelen',
    'Player for {title}': 'Speler voor {title}',
    'Captions': 'Bijschriften',
    'Settings': 'Instellingen',
    'Speed': 'Snelheid',
    'Normal': 'Normaal',
    'Quality': 'Kwaliteit',
    'Loop': 'Loopen',
    'Start': 'Start',
    'End': 'Eind',
    'All': 'Alle',
    'Reset': 'Herstellen',
    'Disabled': 'Uitgeschakeld',
    'Enabled': 'Ingeschakeld',
    'Ad': 'Ad',
    'Action did fail': 'Actie is mislukt',
    'Action was successful': 'Actie was succesvol',
    'Warning': 'Waarschuwing',
    'Information': 'Informatie',
    'Page not found': 'Pagina niet gevonden',
    'The page you were searching for was not found. Click the button below to return to the home page.': 'De pagina waarnaar u zocht is niet gevonden. Klik op de knop hieronder om terug te gaan naar de homepagina.',
    'Add new video': 'Voeg een nieuwe video toe',
    'Go back to home': 'Ga terug naar home',
    'Change your email address': 'Wijzig uw e-mailadres',
    'Change your phone number': 'Wijzig uw telefoonnummer',
    'Change your password': 'Wijzig uw wachtwoord',
    'Change your profile': 'Wijzig uw profiel',
    'Delete section': 'Verwijder sectie',
    'Your phone number could not be updated.': 'Uw telefoonnummer kon niet gewijzigd worden.',
    'The section could not be created.': 'De sectie kon niet worden aangemaakt.',
    'The section could not be updated.': 'De sectie kon niet worden gewijzigd.',
    'The item could not be added.': 'Het item kon niet worden toegevoegd.',
    'Feed images': 'Feed afbeeldingen',
    'Platform by': 'Platform door',
    'The item could not be removed.': 'Het item kon niet worden verwijderd.',
    'New item': 'Nieuw item',
    'Delete item': 'Verwijder item',
    'Add new photo': 'Voeg een nieuwe foto toe',
    'Add new item': 'Voeg een nieuw item toe',
    'E.g. My awesome feed/video/livestream': 'Bijv. Mijn geweldige feed/video/livestream',
    'Search in:': 'Zoeken in:',
    'The section could not be moved.': 'De sectie kon niet worden verplaatst.',
    'Update section': 'Wijzig sectie',
    'The section was successfully deleted.': 'De sectie was succesvol verwijderd.',
    'The section could not be deleted.': 'De sectie kon niet worden verwijderd.',
    'Your current password was incorrect.': 'Uw huidige wachtwoord was incorrect.',
    'Set default': 'Standaard instellen',
    'Current email address': 'Huidig e-mailadres',
    'Current phone number': 'Huidig telefoonnummer',
    'New email address': 'Nieuw e-mailadres',
    'New phone number': 'Nieuw telefoonnummer',
    'Cancel': 'Annuleren',
    'E.g. info@email.com': 'Bijv. info@email.com',
    'Sign up': 'Aanmelden',
    'I understand': 'Ik begrijp het',
    'E.g. ***********': 'Bijv. ***********',
    'Forgot password?': 'Wachtwoord vergeten?',
    'The email address is not recognized.': 'Het emailadres wordt niet herkent.',
    'An email has been sent to reset your password.': 'Een e-mail is verzonden om uw wachtwoord te herstellen.',
    'The email-password combination is not recognized.': 'De email-wachtwoord combinatie wordt niet herkent.',
    'Reset password': 'Wachtwoord herstellen',
    'Logout': 'Uitloggen',
    'Overviews': 'Overzichten',
    'Platforms': 'Platformen',
    'Your profile was successfully updated.': 'Uw profiel was succesvol gewijzigd.',
    'Your profile could not be updated.': 'Uw profiel kon niet gewijzigd worden.',
    'My account': 'Mijn account',
    'Name': 'Naam',
    'E.g. Recent videos': 'Bijv. Recente video\'s',
    'First and last name': 'Voor- en achternaam',
    'You can change your public profile information here. Other users can view this information when you post a comment.': 'U kunt hier uw publieke profielgegevens wijzigen. Andere gebruikers kunnen deze gegevens inzien wanneer u een reactie plaatst.',
    'Save changes': 'Wijzigingen opslaan',
    'Request password': 'Wachtwoord opvragen',
    'Your password has successfully been changed.': 'Uw wachtwoord is succesvol gewijzigd.',
    'Your password could not be changed.': 'Uw wachtwoord kon niet gewijzigd worden.',
    'New password': 'Nieuw wachtwoord',
    'Current password': 'Huidig wachtwoord',
    'Your password should contain at least six characters.': 'Uw wachtwoord moet minimaal 6 karakters bevatten.',
    'Change profile image': 'Wijzig profielafbeelding',
    'It is recommended to use an aspect ratio of 1:1.': 'Het wordt aanbevolen om een beeldverhouding van 1:1 te gebruiken.',
    'It is recommended to use an aspect ratio of 16:9.': 'Het wordt aanbevolen om een beeldverhouding van 16:9 te gebruiken.',
    'E.g. John Doe': 'Bijv. John Doe',
    'E.g. +31638478602': 'Bijv. +31638478602',
    'Change thumbnail': 'Wijzig miniatuurweergave',
    'You have successfully added the photo.': 'U heeft succesvol de foto toegevoegd.',
    'You have successfully removed the photo.': 'U heeft succesvol de foto verwijderd.',
    'Add photo': 'Foto toevoegen',
    'Delete photo': 'Foto verwijderen',
    'Feed': 'Feed',
    'You have successfully changed the thumbnail.': 'U heeft succesvol de miniatuurweergave gewijzigd.',
    'The image does not meet the required format.': 'De afbeelding voldoet niet aan de toegestane formaten.',
    'Delete my account': 'Verwijder mijn account',
    'Thumbnail': 'Miniatuurweergave',
    'I am sure': 'Ik weet het zeker',
    'Uploading': 'Aan het uploaden',
    'Click here to upload your video': 'Klik hier om uw video te uploaden',
    'Processing...': 'Aan het verwerken...',
    'Your video has been successfully uploaded.': 'Uw video is succesvol geüpload.',
    'Are you sure you want to delete this comment?': 'Weet u zeker dat u dit commentaar wilt verwijderen?',
    'This action cannot be undone. Are you absolutely sure you want to do this? Please fill in your email address is you want to delete your account.': 'Deze actie kan niet ongedaan gemaakt worden. Weet u zeker dat u dit wilt doen? Vul uw e-mailadres in als u uw account wilt verwijderen.',
    'Your account has been successfully deleted.': 'Uw account is succesvol verwijderd.',
    'Change password': 'Wijzig wachtwoord',
    'Confirm password': 'Bevestig wachtwoord',
    'Your current password is invalid.': 'Uw huidige wachtwoord was niet correct.',
    'Your password has been successfully changed.': 'Uw wachtwoord is succesvol gewijzigd.',
    'Your data is safely stored in our system. Do you want to remove this data from our systems? Or do you no longer want to use your account? You can delete your complete account with the button on the right.': 'Uw gegevens worden veilig opgeslagen in ons systeem. Wilt u ervoor zorgen dat deze gegevens uit het systeem verwijderd worden? Of wilt u uw account niet meer gebruiken? U kunt uw complete account verwijderen met de knop hiernaast.',
    'Your password is safely stored in our system. If you do not remember your password or want to change the password, you can use the button on the right.': 'Uw wachtwoord is veilig opgeslagen in ons systeem. Als u uw wachtwoord niet meer weet of het wachtwoord wilt wijzigen dan kunt u de knop hiernaast gebruiken.',
    'Create new platform': 'Maak een nieuw platform',
    'Create new video': 'Maak een nieuwe video',
    'Create new feed': 'Maak een nieuwe feed',
    'Create new livestream': 'Maak een nieuwe livestream',
    'Title': 'Titel',
    'E.g. My awesome platform': 'Bijv. Mijn geweldige platform',
    'E.g. My awesome video': 'Bijv. Mijn geweldige video',
    'E.g. My awesome feed': 'Bijv. Mijn geweldige feed',
    'E.g. My awesome livestream': 'Bijv. Mijn geweldige livestream',
    'Subdomain': 'Subdomein',
    'Go back to app': 'Ga terug naar app',
    'E.g. my-subdomain': 'Bijv. mijn-subdomein',
    'Your title can contain a maximum of 40 characters.': 'Uw titel mag maximaal 40 karakters bevatten.',
    'Your title can contain a maximum of 60 characters.': 'Uw titel mag maximaal 60 karakters bevatten.',
    'Your subdomain may not contain spacing or uppercase/special characters.': 'Uw subdomein mag geen spaties of hoofdletters en speciale karakters bevatten.',
    'Create': 'Aanmaken',
    'Description': 'Beschrijving',
    'Upload your video': 'Upload uw video',
    'Delete video': 'Verwijder video',
    'Delete feed': 'Verwijder feed',
    'Delete livestream': 'Verwijder livestream',
    'Feeds': 'Feeds',
    'Livestreams': 'Livestreams',
    'Your content will be displayed to the user.': 'Uw inhoud zal weergeven worden aan de gebruiker.',
    'All your account details remain private to other users. On this page you can download all your monthly invoices and manage your membership.': 'Al uw accountgegevens blijven privé voor andere gebruikers. Op deze pagina kunt u al uw maandelijkse facturen downloaden en het lidmaatschap beheren.',
    'E.g. My description about this platform': 'Bijv. Mijn beschrijving voor dit platform',
    'E.g. My description about this video': 'Bijv. Mijn beschrijving voor deze video',
    'E.g. The content of this feed': 'Bijv. De inhoud van deze feed',
    'Your description should describe the platform.': 'Uw beschrijving moet het platform beschrijven.',
    'Your description should describe your video.': 'Uw beschrijving moet uw video beschrijven.',
    'The platform has been successfully created.': 'Het platform is succesvol aangemaakt.',
    'The video has been successfully created.': 'De video is succesvol aangemaakt.',
    'The feed has been successfully created.': 'De feed is succesvol aangemaakt.',
    'The livestream has been successfully created.': 'De livestream is succesvol aangemaakt.',
    'The platform has been successfully updated.': 'Het platform is succesvol gewijzigd.',
    'The user has been successfully updated.': 'De gebruiker is succesvol gewijzigd.',
    'The video has been successfully updated.': 'De video is succesvol gewijzigd.',
    'The feed has been successfully updated.': 'De feed is succesvol gewijzigd.',
    'The livestream has been successfully updated.': 'De livestream is succesvol gewijzigd.',
    'Livestream embed code': 'Livestream embed code',
    'Chat embed code': 'Chat embed code',
    'Live chat': 'Live chat',
    'Agents': 'Tussenpersonen',
    'Agent': 'Tussenpersoon',
    'E.g. My embed code': 'Bijv. Mijn embed code',
    'You can find your embed code in Vimeo.': 'U kunt uw embed code vinden in Vimeo.',
    'The platform has been successfully deleted.': 'Het platform is succesvol verwijderd.',
    'The video has been successfully deleted.': 'De video is succesvol verwijderd.',
    'The feed has been successfully deleted.': 'De feed is succesvol verwijderd.',
    'The livestream has been successfully deleted.': 'De livestream is succesvol verwijderd.',
    'The content-creator has been successfully deleted.': 'De content-creator is succesvol verwijderd.',
    'The administrator has been successfully created.': 'De administrator is succesvol aangemaakt.',
    'The agent has been successfully created.': 'De tussenpersoon is succesvol aangemaakt.',
    'The content-creator has been successfully created.': 'De content-creator is succesvol aangemaakt.',
    'Search for ${type|lowercase}.': 'Zoeken naar ${type|lowercase}.',
    'Video settings': 'Video instellingen',
    'Feed settings': 'Feed instellingen',
    'Livestream settings': 'Livestream instellingen',
    'Delete this video': 'Verwijder deze video',
    'Delete this feed': 'Verwijder deze feed',
    'Delete this livestream': 'Verwijder deze livestream',
    'You can delete video\'s from your account. If you delete a video it will be permanently removed from your account.': 'U kunt video\'s verwijderen van uw account. Als u een video verwijderd wordt deze permanent verwijderd van uw account.',
    'You can delete feeds from your account. If you delete a feed it will be permanently removed from your account.': 'U kunt feeds verwijderen van uw account. Als u een feed verwijderd wordt deze permanent verwijderd van uw account.',
    'You can delete livestreams from your account. If you delete a livestream it will be permanently removed from your account.': 'U kunt livestreams verwijderen van uw account. Als u een livestream verwijderd wordt deze permanent verwijderd van uw account.',
    'This determines if your video will contain a lock.': 'Dit bepaalt of je video een vergrendeling bevat.',
    'This determines if your feed will contain a lock.': 'Dit bepaalt of je feed een vergrendeling bevat.',
    'This determines if your livestream will contain a lock.': 'Dit bepaalt of je livestream een vergrendeling bevat.',
    'No platforms were found.': 'Er zijn geen platformen gevonden.',
    'No agents were found.': 'Er zijn geen tussenpersonen gevonden.',
    'No videos were found.': 'Er zijn geen video\'s gevonden.',
    'No feeds were found.': 'Er zijn geen feeds gevonden.',
    'No livestreams were found.': 'Er zijn geen livestreams gevonden.',
    'No administrators were found.': 'Er zijn geen administrators gevonden.',
    'No users were found.': 'Er zijn geen gebruikers gevonden.',
    'Go to the platform': 'Ga naar het platform',
    'Go to the video': 'Ga naar de video',
    'Go to the feed': 'Ga naar de feed',
    'Go to the livestream': 'Ga naar de livestream',
    'Content': 'Inhoud',
    'Something went wrong.': 'Er is iets foutgegaan.',
    'Paid?': 'Betaald?',
    'The subdomain is already taken.': 'Het subdomein is al bezet.',
    'Edit platform': 'Wijzig platform',
    'Edit administrator': 'Wijzig administrator',
    'Edit agent': 'Wijzig tussenpersoon',
    'Edit video': 'Wijzig video',
    'Edit feed': 'Wijzig feed',
    'Edit livestream': 'Wijzig livestream',
    'No platform found': 'Geen platform gevonden',
    'Accounts': 'Accounts',
    'No invoices were found.': 'Er zijn geen facturen gevonden.',
    'Cancel my subscription': 'Abonnement opzeggen',
    'Are you sure you want to cancel your subscription?': 'Weet u zeker dat u uw abonnement wilt opzeggen?',
    'Administrators': 'Administrators',
    'Users': 'Gebruikers',
    'General': 'Algemeen',
    'Social media': 'Social media',
    'E.g. Your social link': 'Bijv. Uw sociale link',
    'Website': 'Website',
    'Administrator': 'Administrator',
    'Advanced': 'Geavanceerd',
    'Go back to the overview': 'Ga terug naar het overzicht',
    'Delete this platform': 'Verwijder dit platform',
    'Create a new administrator': 'Maak een nieuwe administrator',
    'Create a new agent': 'Maak een nieuw tussenpersoon',
    'Create a new content-creator': 'Maak een nieuwe content-creator',
    'Edit user': 'Wijzig gebruiker',
    'Delete platform': 'Verwijder platform',
    'Delete': 'Verwijderen',
    'Delete content-creator': 'Verwijder content-creator',
    'Content-creator percentage': 'Content-creator percentage',
    'Admin percentage': 'Admin percentage',
    'Agent percentage': 'Tussenpersoon percentage',
    'The percentages should all add up to 100% to create the platform. And all percentages should be 1 or more.': 'De percentages moeten allemaal tot 100% optellen om het platform te maken. En alle percentages moeten meer dan 1 zijn.',
    'Videos': 'Video\'s',
    'Login': 'Inloggen',
    'Agent (optional)': 'Tussenpersoon (optioneel)',
    'Register': 'Registreren',
    'Reactions': 'Reacties',
    'Show less': 'Minder weergeven',
    'Show more': 'Meer weergeven',
    'Load more': 'Meer laden',
    'Select an agent': 'Selecteer een tussenpersoon',
    'Post': 'Plaatsen',
    'Looks like we\'re having some server issues.': 'Het ziet ernaar uit dat we serverproblemen hebben.',
    'Go back to the previous page and try again.': 'Ga terug naar de vorige pagina en probeer het opnieuw.',
    'Add a public comment...': 'Voeg een openbare opmerking toe...',
    'No comments were found.': 'Er zijn geen reacties gevonden.',
    'You can add a comment with the text box above.': 'U kunt een reactie geven via de tekstbox hierboven.',
    'Go back to the homepage': 'Ga terug naar de homepagina',
    'I agree with the': 'Ik ga akkoord met de',
    'terms and conditions': 'algemene voorwaarden',
    'and the': 'en het',
    'Reply': 'Beantwoorden',
    'To my account': 'Naar mijn account',
    'Manage platform': 'Platform beheren',
    'privacy statement': 'privacybeleid',
    'Do you already have an account? Login': 'Heeft u al een account? Inloggen',
    'Exclusive videos': 'Exclusieve video\'s',
    'Exclusive interaction': 'Exclusieve interactie',
    'Early access to new videos': 'Snel toegang tot nieuwe video\'s',
    'Exclusive giveaways': 'Exclusieve acties',
    'No advertisements': 'Geen advertenties',
    'Contests, exclusive benefits and more': 'Winacties, exclusieve voordelen en meer',
    'Register complete': 'Registratie voltooid',
    'Your account has successfully been created.': 'Uw account is succesvol aangemaakt.',
    'Watch videos now!': 'Nu video\'s bekijken!',
    'Discounts on the webshop': 'Korting op de webshop',
    'Acquire great discounts on the merchandise store': 'Verkrijg leuke kortingen in de webshop',
    'E.g. #ffffff': 'Bijv. #ffffff',
    'Max width': 'Max breedte',
    'Background color': 'Achtergrondkleur',
    'Header text color': 'Header tekstkleur',
    'Header border color': 'Header randkleur',
    'Header background color': 'Header achtergrondkleur',
    'Footer text color': 'Footer tekstkleur',
    'Full width': 'Volledige breedte',
    'Change your subscription': 'Wijzig uw abonnement',
    'Footer border color': 'Footer randkleur',
    'Footer background color': 'Footer achtergrondkleur',
    'My platform': 'Mijn platform',
    'Styles': 'Styles',
    'E.g. 1200px': 'Bijv. 1200px',
    'Terms and conditions': 'Algemene voorwaarden',
    'Privacy statement': 'Privacybeleid',
    'Total amount of views': 'Totaal aantal weergeven',
    'Show invoices': 'Bekijk facturen',
    'Date': 'Datum',
    'Price': 'Prijs',
    'Product': 'Product',
    'E.g. New York': 'Bijv. Nijmegen',
    'City': 'Woonplaats',
    'Street': 'Straat',
    'Address data': 'Adresgegevens',
    'E.g. Time Square': 'Bijv. Welderenstraat',
    'Total amount of likes': 'Totaal aantal likes',
    'All rights reserved.': 'Alle rechten voorbehouden.',
    'Go back': 'Ga terug',
    'Don\'t have an account? Register': 'Nog geen account? Registreren',
    'Content only accessible for members': 'Content alleen beschikbaar voor leden',
    'No more annoying ads': 'Geen ergernis rondom advertenties',
    'Watch content earlier than on YouTube': 'Bekijk content eerder dan op YouTube',
    'Easier interaction with the creator': 'Makkelijker interactie met de creator',
    'Yearly subscription': 'Jaarlijks abonnement',
    'Monthly subscription': 'Maandelijks abonnement',
    'No subscription': 'Geen abonnement',
    'No videos': 'Geen video\'s',
    'Your subscription ends on': 'Uw abonnement eindigt op',
    'I declare to be sixteen years of age or older, or to have permission from a parent or guardian.': 'Ik verklaar zestien jaar of ouder te zijn, of toestemming te hebben van ouder of voogd.',
    'I agree with the direct delivery of this service and thus renounce my right of withdrawal.': 'Ik stem in met directe levering van deze dienst en zie daarmee af van mijn recht tot herroeping.',
    'Something went wrong while registering.': 'Er is iets fout gegaan tijdens het registreren.',
    'This action cannot be undone. Are you absolutely sure you want to do this?': 'Deze actie kan niet ongedaan gemaakt worden. Weet u zeker dat u dit wilt doen?',
    'This action cannot be undone. Are you absolutely sure you want to do this? Please fill in the title of the platform to delete it.': 'Deze actie kan niet ongedaan gemaakt worden. Weet u zeker dat u dit wilt doen? Vul de titel van het platform in als u deze wilt verwijderen.',
    'Do you want to delete all records of this platform from the system? You can do this with this button. This action cannot be reversed.': 'Wilt u alle gegevens van dit platform verwijderen van het systeem? U kunt dit doen met deze knop. Deze actie kan niet teruggedraaid worden.',
    'Are you sure you want to delete this platform?': 'Weet u zeker dat u dit platform wilt verwijderen?',
    'The email address has already been taken.': 'Het emailadres is al bezet.',
    'You will be redirected to the payment page.': 'U wordt doorverwezen naar de betaalpagina.',
    'You can add new content-creators to this platform. Content-creators have rights to edit the platform.': 'U kunt nieuwe content-creators toevoegen aan dit platform. Content-creators hebben rechten om het platform te wijzigen.',
    'Euro': 'Euro',
    'United States Dollar': 'Amerikaanse dollar',
    'Australia Dollar': 'Australische dollar',
    'Brazil Real': 'Braziliaanse real',
    'United Kingdom Pound': 'Britse pond',
    'Bulgaria Lev': 'Bulgaarse lev',
    'Canada Dollar': 'Canadese dollar',
    'Denmark Krone': 'Deense kroon',
    'Philippines Peso': 'Filipijnse peso',
    'Hungary Forint': 'Hongaarse forint',
    'Hong Kong Dollar': 'Hong Kong dollar',
    'Iceland Krona': 'IJslandse kroon',
    'Israel Shekel': 'Israëlische shekel',
    'Japan Yen': 'Japanse yen',
    'Croatia Kuna': 'Kroatische kuna',
    'Malaysia Ringgit': 'Maleisische ringgit',
    'Mexico Peso': 'Mexicaanse peso',
    'New Zealand Dollar': 'Nieuw Zeelandse dollar',
    'Norway Krone': 'Noorse kroon',
    'Poland Zloty': 'Poolse zloty',
    'Romania New Leu': 'Roemeense leu',
    'Russia Ruble': 'Russische roebel',
    'Singapore Dollar': 'Singaporese dollar',
    'Taiwan New Dollar': 'Taiwanese dollar',
    'Thailand Baht': 'Thaise baht',
    'Czech Republic Koruna': 'Tsjechische kroon',
    'Sweden Krona': 'Zweedse kroon',
    'Switzerland Franc': 'Zwitserse frank',
    'Afghanistan': 'Afghanistan',
    'Aland Islands': 'Åland',
    'Albania': 'Albanië',
    'Algeria': 'Algerije',
    'U.S. Virgin Islands': 'Amerikaanse Maagdeneilanden',
    'American Samoa': 'Amerikaans-Samoa',
    'Andorra': 'Andorra',
    'Angola': 'Angola',
    'Anguilla': 'Anguilla',
    'Antarctica': 'Antarctica',
    'Antigua and Barbuda': 'Antigua en Barbuda',
    'Argentina': 'Argentinië',
    'Armenia': 'Armenië',
    'Aruba': 'Aruba',
    'Australia': 'Australië',
    'Azerbaijan': 'Azerbeidzjan',
    'Bahamas': 'Bahama\'s',
    'Bahrain': 'Bahrein',
    'Bangladesh': 'Bangladesh',
    'Barbados': 'Barbados',
    'Belgium': 'België',
    'Belize': 'Belize',
    'Benin': 'Benin',
    'Bermuda': 'Bermuda',
    'Bhutan': 'Bhutan',
    'Bolivia': 'Bolivia',
    'Bonaire, Saint Eustatius and Saba ': 'Bonaire, Sint Eustatius en Saba',
    'Bosnia and Herzegovina': 'Bosnië en Herzegovina',
    'Botswana': 'Botswana',
    'Bouvet Island': 'Bouvet',
    'Brazil': 'Brazilië',
    'British Virgin Islands': 'Britse Maagdeneilanden',
    'British Indian Ocean Territory': 'Brits Indische Oceaanterritorium',
    'Brunei': 'Brunei',
    'Bulgaria': 'Bulgarije',
    'Burkina Faso': 'Burkina Faso',
    'Burundi': 'Burundi',
    'Cambodia': 'Cambodja',
    'Canada': 'Canada',
    'Central African Republic': 'Centraal-Afrikaanse Republiek',
    'Chile': 'Chili',
    'China': 'China',
    'Christmas Island': 'Christmaseiland',
    'Cocos Islands': 'Cocoseilanden',
    'Colombia': 'Colombia',
    'Comoros': 'Comoren',
    'Republic of the Congo': 'Congo-Brazzaville',
    'Democratic Republic of the Congo': 'Congo-Kinshasa',
    'Cook Islands': 'Cookeilanden',
    'Costa Rica': 'Costa Rica',
    'Cuba': 'Cuba',
    'Curacao': 'Curaçao',
    'Cyprus': 'Cyprus',
    'Denmark': 'Denemarken',
    'Djibouti': 'Djibouti',
    'Dominica': 'Dominica',
    'Dominican Republic': 'Dominicaanse Republiek',
    'Germany': 'Duitsland',
    'Ecuador': 'Ecuador',
    'Egypt': 'Egypte',
    'El Salvador': 'El Salvador',
    'Equatorial Guinea': 'Equatoriaal-Guinea',
    'Eritrea': 'Eritrea',
    'Estonia': 'Estland',
    'Ethiopia': 'Ethiopië',
    'Faroe Islands': 'Faeröer',
    'Falkland Islands': 'Falklandeilanden',
    'Fiji': 'Fiji',
    'Philippines': 'Filipijnen',
    'Finland': 'Finland',
    'France': 'Frankrijk',
    'French Southern Territories': 'Franse Zuidelijke en Antarctische Gebiede',
    'French Guiana': 'Frans-Guyana',
    'French Polynesia': 'Frans-Polynesië',
    'Gabon': 'Gabon',
    'Gambia': 'Gambia',
    'Georgia': 'Georgië',
    'Ghana': 'Ghana',
    'Gibraltar': 'Gibraltar',
    'Grenada': 'Grenada',
    'Greece': 'Griekenland',
    'Greenland': 'Groenland',
    'Guadeloupe': 'Guadeloupe',
    'Guam': 'Guam',
    'Guatemala': 'Guatemala',
    'Guernsey': 'Guernsey',
    'Guinea': 'Guinee',
    'Guinea-Bissau': 'Guinee-Bissau',
    'Guyana': 'Guyana',
    'Haiti': 'Haïti',
    'Heard Island and McDonald Islands': 'Heard en McDonaldeilanden',
    'Honduras': 'Honduras',
    'Hungary': 'Hongarije',
    'Hong Kong': 'Hongkong',
    'Ireland': 'Ierland',
    'Iceland': 'IJsland',
    'India': 'India',
    'Indonesia': 'Indonesië',
    'Iraq': 'Irak',
    'Iran': 'Iran',
    'Israel': 'Israël',
    'Italy': 'Italië',
    'Ivory Coast': 'Ivoorkust',
    'Jamaica': 'Jamaica',
    'Japan': 'Japan',
    'Yemen': 'Jemen',
    'Jersey': 'Jersey',
    'Jordan': 'Jordanië',
    'Cayman Islands': 'Kaaimaneilanden',
    'Cape Verde': 'Kaapverdië',
    'Cameroon': 'Kameroen',
    'Kazakhstan': 'Kazachstan',
    'Kenya': 'Kenia',
    'Kyrgyzstan': 'Kirgizië',
    'Kiribati': 'Kiribati',
    'United States Minor Outlying Islands': 'Kleine afgelegen eilanden van de Verenigde Staten',
    'Kuwait': 'Koeweit',
    'Kosovo': 'Kosovo',
    'Croatia': 'Kroatië',
    'Laos': 'Laos',
    'Lesotho': 'Lesotho',
    'Latvia': 'Letland',
    'Lebanon': 'Libanon',
    'Liberia': 'Liberia',
    'Libya': 'Libië',
    'Liechtenstein': 'Liechtenstein',
    'Lithuania': 'Litouwen',
    'Luxembourg': 'Luxemburg',
    'Macao': 'Macau',
    'Macedonia': 'Macedonië',
    'Madagascar': 'Madagaskar',
    'Malawi': 'Malawi',
    'Maldives': 'Maldiven',
    'Malaysia': 'Maleisië',
    'Mali': 'Mali',
    'Malta': 'Malta',
    'Isle of Man': 'Man',
    'Morocco': 'Marokko',
    'Marshall Islands': 'Marshalleilanden',
    'Martinique': 'Martinique',
    'Mauritania': 'Mauritanië',
    'Mauritius': 'Mauritius',
    'Mayotte': 'Mayotte',
    'Mexico': 'Mexico',
    'Micronesia': 'Micronesia',
    'Moldova': 'Moldavië',
    'Monaco': 'Monaco',
    'Mongolia': 'Mongolië',
    'Montenegro': 'Montenegro',
    'Montserrat': 'Montserrat',
    'Mozambique': 'Mozambique',
    'Myanmar': 'Myanmar',
    'Namibia': 'Namibië',
    'Nauru': 'Nauru',
    'Netherlands': 'Nederland',
    'Nepal': 'Nepal',
    'Nicaragua': 'Nicaragua',
    'New Caledonia': 'Nieuw-Caledonië',
    'New Zealand': 'Nieuw-Zeeland',
    'Niger': 'Niger',
    'Nigeria': 'Nigeria',
    'Niue': 'Niue',
    'Northern Mariana Islands': 'Noordelijke Marianen',
    'North Korea': 'Noord-Korea',
    'Norway': 'Noorwegen',
    'Norfolk Island': 'Norfolk',
    'Uganda': 'Oeganda',
    'Ukraine': 'Oekraïne',
    'Uzbekistan': 'Oezbekistan',
    'Oman': 'Oman',
    'Austria': 'Oostenrijk',
    'East Timor': 'Oost-Timor',
    'Pakistan': 'Pakistan',
    'Palau': 'Palau',
    'Palestinian Territory': 'Palestina',
    'Panama': 'Panama',
    'Papua New Guinea': 'Papua-Nieuw-Guinea',
    'Paraguay': 'Paraguay',
    'Peru': 'Peru',
    'Pitcairn': 'Pitcairneilanden',
    'Poland': 'Polen',
    'Portugal': 'Portugal',
    'Puerto Rico': 'Puerto Rico',
    'Qatar': 'Qatar',
    'Reunion': 'Réunion',
    'Romania': 'Roemenië',
    'Russia': 'Rusland',
    'Rwanda': 'Rwanda',
    'Saint Barthelemy': 'Saint-Barthélemy',
    'Saint Kitts and Nevis': 'Saint Kitts en Nevis',
    'Saint Lucia': 'Saint Lucia',
    'Saint Pierre and Miquelon': 'Saint-Pierre en Miquelon',
    'Saint Vincent and the Grenadines': 'Saint Vincent en de Grenadines',
    'Solomon Islands': 'Salomonseilanden',
    'Samoa': 'Samoa',
    'San Marino': 'San Marino',
    'Saudi Arabia': 'Saoedi-Arabië',
    'Sao Tome and Principe': 'Sao Tomé en Principe',
    'Senegal': 'Senegal',
    'Serbia': 'Servië',
    'Seychelles': 'Seychellen',
    'Sierra Leone': 'Sierra Leone',
    'Singapore': 'Singapore',
    'Saint Helena': 'Sint-Helena, Ascension en Tristan da Cunha',
    'Saint Martin': 'Sint-Maarten',
    'Sint Maarten': 'Sint Maarten',
    'Slovenia': 'Slovenië',
    'Slovakia': 'Slowakije',
    'Sudan': 'Soedan',
    'Somalia': 'Somalië',
    'Spain': 'Spanje',
    'Svalbard and Jan Mayen': 'Spitsbergen en Jan Mayen',
    'Sri Lanka': 'Sri Lanka',
    'Suriname': 'Suriname',
    'Swaziland': 'Swaziland',
    'Syria': 'Syrië',
    'Tajikistan': 'Tadzjikistan',
    'Taiwan': 'Taiwan',
    'Tanzania': 'Tanzania',
    'Thailand': 'Thailand',
    'Togo': 'Togo',
    'Tokelau': 'Tokelau',
    'Tonga': 'Tonga',
    'Trinidad and Tobago': 'Trinidad en Tobago',
    'Chad': 'Tsjaad',
    'Czech Republic': 'Tsjechië',
    'Tunisia': 'Tunesië',
    'Turkey': 'Turkije',
    'Turkmenistan': 'Turkmenistan',
    'Turks and Caicos Islands': 'Turks- en Caicoseilanden',
    'Tuvalu': 'Tuvalu',
    'Uruguay': 'Uruguay',
    'Vanuatu': 'Vanuatu',
    'Vatican': 'Vaticaanstad',
    'Venezuela': 'Venezuela',
    'United Arab Emirates': 'Verenigde Arabische Emiraten',
    'United States': 'Verenigde Staten',
    'United Kingdom': 'Verenigd Koninkrijk',
    'Vietnam': 'Vietnam',
    'Wallis and Futuna': 'Wallis en Futuna',
    'Western Sahara': 'Westelijke Sahara',
    'Belarus': 'Wit-Rusland',
    'Zambia': 'Zambia',
    'Zimbabwe': 'Zimbabwe',
    'South Africa': 'Zuid-Afrika',
    'South Georgia and the South Sandwich Islands': 'Zuid-Georgia en de Zuidelijke Sandwicheilanden',
    'South Korea': 'Zuid-Korea',
    'South Sudan': 'Zuid-Soedan',
    'Sweden': 'Zweden',
    'Switzerland': 'Zwitserland'
};
